<script>
export default {
    name: 'EventListener',
    render() {
        return this.$slots.default;
    }
}
</script>